import Cookies from 'js-cookie';

const CF_CACHE_STATUS_COOKIE = 'cf_cache_status';

// Cloudflare cache status values.
// See: https://developers.cloudflare.com/cache/concepts/cache-responses/
export type CacheStatus =
  | 'HIT'
  | 'MISS'
  | 'DYNAMIC'
  | 'BYPASS'
  | 'EXPIRED'
  | 'STALE'
  | 'REVALIDATED'
  | 'UPDATING';

/**
 * Returns the Cloudflare cache status from the cf_cache_status cookie.
 * Returns null if the cookie is not set.
 */
export function getCloudflareCacheStatus(): CacheStatus | null {
  const status = Cookies.get(CF_CACHE_STATUS_COOKIE);
  if (!status) return null;
  return status as CacheStatus;
}
